import React, { Component } from "react";
import { Table, Card, Row, Col, Image, Button } from "react-bootstrap";
import AddTermsandCondition from "./AddTermsandCondition";
import EditTermsandCondition from "./EditTermsandCondition";
import TermsandConditionViewModel from "./TermsandConditionViewModel";
var dateFormat = require("dateformat");
class TermsandCondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTrmsadCndtnAddModel: false,
      showTrmsadCndtnEditModel: false,
      TermsandConditionViewShow: false,
    };
  }

  componentDidMount() {
    this.props.fetchTermsandCondition();
  }
  handleAddTermsandCondition = () => {
    this.setState({
      showTrmsadCndtnAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showTrmsadCndtnAddModel: false,
    });
  };

  handleTermsandConditionView = (item) => {
    this.setState({
      TermsandConditionViewShow: true,
      TermsandConditionDtls: item,
    });
  };

  handleCloseTermsandCondition = () => {
    this.setState({ TermsandConditionViewShow: false });
  };

  handleEditTermsandCondition = (item) => {
    this.setState({
      showTrmsadCndtnEditModel: true,
      ItemList: item,
    });
  };
  closeEditModel = () => {
    this.setState({
      showTrmsadCndtnEditModel: false,
    });
  };
  render() {
    const count =
      this.props.TrmsadCondtonDtList && this.props.TrmsadCondtonDtList.length;
    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Terms & Conditions</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddTermsandCondition()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddTermsandCondition
                showTrmsadCndtnAddModel={this.state.showTrmsadCndtnAddModel}
                closeAddModel={this.closeAddModel}
                AddTrmsadCndtn={this.props.AddTrmsadCndtn}
              />
            </div>
            <div>
              <Table responsive className="cmnMainTable" bordered striped>
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>Terms Url</th>
                    <th>Terms Version</th>
                    <th>Privacy Url</th>
                    <th>Privacy Version</th>
                    <th>ACTIVE</th>
                    <th>CREATED DATE</th>
                    <th>Updated Date</th>

                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.TrmsadCondtonDtList &&
                    this.props.TrmsadCondtonDtList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{i + 1}</td>
                        <td className="commonDesc">
                          {" "}
                          {item !== null && item.termsUrl}
                        </td>
                        <td> {item !== null && item.termsV}</td>
                        <td className="commonDesc">
                          {" "}
                          {item !== null && item.privacyUrl}
                        </td>
                        <td> {item !== null && item.privacyV}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.isActive ? "Yes" : "No"}
                        </td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>

                        <td className="cmn_Cap">
                          {item.updatedAt !== null &&
                            dateFormat(item.updatedAt, "mediumDate")}
                        </td>

                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handleTermsandConditionView({
                                  item: item,
                                })
                              }
                            ></i>
                            <TermsandConditionViewModel
                              show={this.state.TermsandConditionViewShow}
                              handleClose={this.handleCloseTermsandCondition}
                              TermsandConditionDtls={
                                this.state.TermsandConditionDtls
                              }
                            />
                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() =>
                                this.handleEditTermsandCondition(item)
                              }
                            ></i>
                            <EditTermsandCondition
                              showTrmsadCndtnEditModel={
                                this.state.showTrmsadCndtnEditModel
                              }
                              closeEditModel={this.closeEditModel}
                              ItemList={this.state.ItemList}
                              EditTrmsadCndtn={this.props.EditTrmsadCndtn}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {(this.props.TrmsadCondtonDtList === undefined ||
                (this.props.TrmsadCondtonDtList &&
                  this.props.TrmsadCondtonDtList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      alt="NoDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No T&C Found</div>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default TermsandCondition;
